import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { IoMdTime } from 'react-icons/io';

import { secondsToHHMMSS } from '../../../utils/time';
import { BannerBackground } from './BannerBackground';
import PromoContent from './PromoContent';

import {
  Container,
  Content,
  CountdownBox,
  CountdownLabel,
  CountdownLabelText,
  CountdownSection,
  CountdownTime,
  ProgressBarFill,
  ProgressBarTrack,
} from './styles';

const PromoNovosLojistasBanner = ({ bannerConfig, remainingSeconds, progress }) => {
  const handleBannerClick = useCallback(() => {
    if (!bannerConfig?.isClickable || !bannerConfig?.link) return;

    try {
      window.open(bannerConfig.link, '_blank');
    } catch (error) {
      console.warn('Erro ao abrir link:', error);
    }
  }, [bannerConfig]);

  if (!bannerConfig || remainingSeconds <= 0) {
    return null;
  }

  const displayTime = secondsToHHMMSS(remainingSeconds);

  return (
    <Container
      id="banner-promo-novos-lojistas"
      data-gtm-banner="promo-novos-lojistas"
      onClick={handleBannerClick}
      style={{
        cursor: bannerConfig.isClickable ? 'pointer' : 'default',
      }}
    >
      <BannerBackground />

      <Content>
        <PromoContent
          bonusAmount={bannerConfig.bonusAmount}
          badgeText={bannerConfig.badgeText}
          durationHoursLabel={bannerConfig.durationHoursLabel}
        />

        <CountdownSection>
          <CountdownLabel>
            <IoMdTime color="#fff" size={11} aria-hidden />
            <CountdownLabelText>Tempo restante:</CountdownLabelText>
          </CountdownLabel>

          <CountdownBox>
            <CountdownTime id="banner-promo-countdown">{displayTime}</CountdownTime>
            <ProgressBarTrack>
              <ProgressBarFill progress={progress} />
            </ProgressBarTrack>
          </CountdownBox>
        </CountdownSection>
      </Content>
    </Container>
  );
};

PromoNovosLojistasBanner.propTypes = {
  bannerConfig: PropTypes.shape({
    bonusAmount: PropTypes.string.isRequired,
    badgeText: PropTypes.string.isRequired,
    durationHoursLabel: PropTypes.string.isRequired,
    isClickable: PropTypes.bool,
    link: PropTypes.string,
  }).isRequired,
  remainingSeconds: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired,
};

export default PromoNovosLojistasBanner;
